import { render } from "./StadaPopup.vue?vue&type=template&id=303ee6fb"
import script from "./StadaPopup.vue?vue&type=script&lang=js"
export * from "./StadaPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__